import React from "react";

import { MascotFrame, skinTones } from "./MascotFrame";

export function OzArt({ className }: { className?: string }) {
  return (
    <MascotFrame
      className={className}
      backdropClassName="bg-mascot-backdrop-green"
    >
      <path d="M12 42c0-8 5.5-14 12-14s12 6 12 14z" className="fill-gray-700" />
      <path
        d="M20.8 28.3 24 31.5l3.2-3.2a12 12 0 0 0-6.4 0z"
        className="fill-white"
      />
      <path
        d="M20.5 27.2 24 29l-3.5 1.8zm7 0L24 29l-3.5 1.8z"
        className="fill-yellow-500"
      />
      <rect x="21.5" y="24" width="5" height="4" className={skinTones.light} />
      <circle cx="16.6" cy="19.5" r="1.7" className={skinTones.light} />
      <circle cx="31.4" cy="19.5" r="1.7" className={skinTones.light} />
      <circle cx="24" cy="19" r="7.5" className={skinTones.light} />
      <ellipse cx="17" cy="16.5" rx="1.8" ry="2.8" className="fill-gray-200" />
      <ellipse cx="31" cy="16.5" rx="1.8" ry="2.8" className="fill-gray-200" />
      <g className="stroke-green-800" strokeWidth="1.2">
        <circle cx="21" cy="19" r="2.6" className="fill-green-300" />
        <circle cx="27" cy="19" r="2.6" className="fill-green-300" />
        <path d="M23.6 19h.8" />
      </g>
      <circle cx="21" cy="19" r=".9" className="fill-gray-800" />
      <circle cx="27" cy="19" r=".9" className="fill-gray-800" />
      <path
        d="M21.5 23q2.5 1.8 5 0"
        className="fill-none stroke-gray-800"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <path d="M2 34.5 16.5 31v17H2z" className="fill-green-800" />
      <path d="M16.5 31h15v17h-15z" className="fill-green-700" />
      <path d="M31.5 31 46 34.5V48H31.5z" className="fill-green-800" />
      <path
        d="M5 37.5 13.5 35.5v9H5zm29.5-2 8.5 2v7h-8.5z"
        className="fill-none stroke-green-700"
        strokeWidth=".9"
      />
      <path d="m24 35.5 3 4.5-3 4.5-3-4.5z" className="fill-green-300" />
      <path
        d="M2 34.5 16.5 31h15L46 34.5M16.5 31v17m15-17v17"
        className="fill-none stroke-yellow-500"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <circle cx="19.2" cy="31" r="1.8" className={skinTones.light} />
      <circle cx="28.8" cy="31" r="1.8" className={skinTones.light} />
    </MascotFrame>
  );
}
